import React from 'react';
import loadable from 'Components/AsyncModuleLoader/AsyncModuleLoader';
import LazyLoader from 'Components/LazyLoader/LazyLoader';

export default loadable({
    loader: () => import(/* webpackChunkName: "notificationsList" */'./NotificationsList'),
    loading: <LazyLoader containerSize="40px" stroke="4px" />
});
